import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for transaction card customisation
 * Returns styling for transaction items
 */
export const useTransactionCardCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_TRANSACTIONS,
    sectionKey: PUI.CHATBOT_TRANSACTIONS_SECTION_KEYS.TRANSACTION_CARD,
    blockKey: PUI.CHATBOT_TRANSACTIONS_BLOCK_KEYS.TRANSACTIONS,
  });

  const iconColor = getField(PUI.COMMON_FIELD_KEYS.ICON);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const subTextColor = getField(PUI.COMMON_FIELD_KEYS.SUB_TEXT_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);
  const selectedBorderColor = getField(PUI.COMMON_FIELD_KEYS.SELECTED_BORDER_COLOR);
  const selectedIconColor = getField(PUI.COMMON_FIELD_KEYS.SELECTED_TEXT_COLOR);
  const selectedBackgroundColor = getField(PUI.COMMON_FIELD_KEYS.SELECTED_BACKGROUND_COLOR);

  return {
    isVisible,
    iconColor,
    textColor,
    subTextColor,
    backgroundColor,
    borderColor,
    selectedBorderColor,
    selectedIconColor,
    selectedBackgroundColor,
  };
};

/**
 * Composable for user selected transaction card customisation
 * Returns styling for user-selected transaction display
 */
export const useUserSelectedTransactionCardCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_TRANSACTIONS,
    sectionKey: PUI.CHATBOT_TRANSACTIONS_SECTION_KEYS.USER_SELECTED_TRANSACTION_CARD,
    blockKey: PUI.CHATBOT_TRANSACTIONS_BLOCK_KEYS.TRANSACTIONS,
  });

  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const subTextColor = getField(PUI.COMMON_FIELD_KEYS.SUB_TEXT_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);
  const actionIconColor = getField(PUI.COMMON_FIELD_KEYS.ACTION_ICON);

  return {
    isVisible,
    textColor,
    subTextColor,
    backgroundColor,
    borderColor,
    actionIconColor,
  };
};
